/* global wp */
import logo from '../images/login/logo.png';
import logo2x from '../images/login/logo@2x.png';
import logo3x from '../images/login/logo@3x.png';
import GoogleForm from './login/google-form';
import LoginForm from './login/login-form';
import { get } from 'lodash';
import SideTabs from './elements/side-tabs';
import { createInterpolateElement } from '@wordpress/element';
import Button from './elements/button';

const { __ } = wp.i18n;
const { useState } = wp.element;

const Login = () => {
	const [selectedTab, changeSelectedTab] = useState(get(
		window,
		'hubConnectorVars.current_tab',
		'register'
	));

	const { login_title, login_desc } = get(
		window,
		'hubConnectorVars.texts',
		false
	);

	const handleTabChange = (tab) => {
		changeSelectedTab(tab);
	};

	return (
		<main className="sui-wrap">
			<div className="dashui-onboarding">
				<div className="dashui-onboarding-body dashui-onboarding-content-center">
					<div className="dashui-login-form">
						<img
							src={logo}
							srcSet={`${logo} 1x, ${logo2x} 2x, ${logo3x} 3x`}
							className="dashui-onboarding-logo"
							alt={__('Login', 'wpmudev')}
						/>
						<h2>{login_title}</h2>
						<SideTabs
							value={selectedTab}
							onChange={(tab) => handleTabChange(tab)}
							tabs={{
								register: __('I am a new user', 'wpmudev'),
								login: __('I am an existing user', 'wpmudev'),
							}}
						/>
						{selectedTab === 'register' && (
							<>
								<p>
									{createInterpolateElement(
										__(
											"Create a free account to connect your site to WPMU DEV and activate cloud-based link checker. <i>It's fast, seamless, and free.</i>",
											'wpmudev'
										),
										{ i: <i/> }
									)}
								</p>
								<Button
									className="dashui-button"
									href={get(window, 'hubConnectorVars.login.register_url', '')}
								>
									{__('Create a free account', 'wpmudev')}
								</Button>
							</>
						)}
						{selectedTab === 'login' && (
							<>
								<p>{login_desc}</p>
								<GoogleForm/>
								<div className="form-separator">
									<p className="sui-description">
										{__('OR continue with email', 'wpmudev')}
									</p>
								</div>
								<LoginForm/>
							</>
						)}
					</div>
				</div>
			</div>
		</main>
	);
};

export default Login;
